import keyMirror from "keymirror";

export default keyMirror({
    default: null,
    denied: null,
    granted: null,
});
